import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios'; // Import axios

// Thunk for fetching admin referral bonuses
export const fetchAdminReferralBonuses = createAsyncThunk(
    'referral/fetchAdminBonuses',
    async (_, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(
                `${process.env.REACT_APP_SERVER_API}/referrals/admin/partner-bonuses/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            return response.data; // Assuming response.data contains the array of experts
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message || 'Failed to fetch referral bonuses');
        }
    }
);

// Thunk for resetting an expert's referral bonus
export const resetAdminReferralBonus = createAsyncThunk(
    'referral/resetAdminBonus',
    async ({ expertId, reason }, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('token');
            // The API call itself doesn't return data, so we don't assign it to a response variable
            await axios.post(
                `${process.env.REACT_APP_SERVER_API}/referrals/bonus-resets/`,
                { expert: expertId, reason }, // request body
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            return { expertId }; // Indicate success
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message || 'Failed to reset referral bonus');
        }
    }
);

// Thunk for fetching admin bonus reset history
export const fetchAdminBonusResetHistory = createAsyncThunk(
    'referral/fetchAdminBonusResetHistory',
    async (_, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(
                `${process.env.REACT_APP_SERVER_API}/referrals/bonus-resets/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            return response.data; // Assuming response.data contains the array of history items
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message || 'Failed to fetch bonus reset history');
        }
    }
); 